<template>
  <div>
    <validation-observer v-slot="{ invalid }">
      <v-row>
        <v-col>
          <v-card elevation="1" class="pt-7">
            <h2 class="page-title pl-8">
              กรอกข้อมูลคำเสนอขอขายไฟฟ้า
              {{ project_data.project_title }}
            </h2>
            <v-stepper
              vertical
              v-model="e6"
              class="elevation-0 ppim-stepper no-transition"
            >
              <v-stepper-step
                editable
                step="1"
                color="purple"
                :complete="e6 > 1"
                >ข้อมูลผู้สมัครโครงการ
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-row>
                  <v-col v-if="is_person" cols="12" class="form-title"
                    ><v-icon left>fas fa-user</v-icon>ชื่อนาม - สกุล</v-col
                  >
                  <v-col v-else cols="12" class="form-title"
                    ><v-icon left>fas fa-building</v-icon>ชื่อนิติบุคคล</v-col
                  >
                  <v-col cols="12">
                    <v-card elevation="0" color="grey lighten-4" class="pa-3">
                      {{ full_name }}
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="is_person" class="form-title"
                    ><v-icon left>fas fa-map-marker-alt</v-icon
                    >ที่อยู่ตามทะเบียนบ้าน</v-col
                  >
                  <v-col v-else class="form-title"
                    ><v-icon left>fas fa-map-marker-alt</v-icon
                    >ที่อยู่ตามทะเบียนกรมพัฒนาธุรกิจการค้า</v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" color="grey lighten-4" class="pa-3">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          class="text-sm-right pb-1 pb-sm-3 label"
                          >หมู่บ้าน/อาคาร</v-col
                        >
                        <v-col cols="12" sm="8" md="9" class="pt-0 pt-sm-3">{{
                          user.address.home_name
                        }}</v-col>
                        <v-col
                          cols="6"
                          sm="4"
                          md="3"
                          class="text-sm-right label"
                          >ห้อง</v-col
                        >
                        <v-col cols="6" sm="8" md="3">{{
                          user.address.room_no
                        }}</v-col>
                        <v-col
                          cols="6"
                          sm="4"
                          md="3"
                          class="text-sm-right label"
                          >ชั้น</v-col
                        >
                        <v-col cols="6" sm="8" md="3">{{
                          user.address.floor
                        }}</v-col>
                        <v-col
                          cols="6"
                          sm="4"
                          md="3"
                          class="text-sm-right label"
                          >บ้านเลขที่</v-col
                        >
                        <v-col cols="6" sm="8" md="3">{{
                          user.address.home_no
                        }}</v-col>
                        <v-col
                          cols="6"
                          sm="4"
                          md="3"
                          class="text-sm-right label"
                          >หมู่ที่</v-col
                        >
                        <v-col cols="6" sm="8" md="3">{{
                          user.address.moo
                        }}</v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          class="text-sm-right pb-1 pb-sm-3 label"
                          >ถนน/ซอย</v-col
                        >
                        <v-col cols="12" sm="8" md="9" class="pt-0 pt-sm-3">{{
                          full_street
                        }}</v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          class="text-sm-right pb-1 pb-sm-3 label"
                          >ตำบล/แขวง</v-col
                        >
                        <v-col cols="12" sm="8" md="3" class="pt-0 pt-sm-3">{{
                          user.address.tumbon_text
                        }}</v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          class="text-sm-right pb-1 pb-sm-3 label"
                          >อำเภอ/เขต</v-col
                        >
                        <v-col cols="12" sm="8" md="3" class="pt-0 pt-sm-3">{{
                          user.address.amphor_text
                        }}</v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          class="text-sm-right pb-1 pb-sm-3 label"
                          >จังหวัด</v-col
                        >
                        <v-col cols="12" sm="8" md="3" class="pt-0 pt-sm-3">{{
                          user.address.province_text
                        }}</v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          class="text-sm-right pb-1 pb-sm-3 label"
                          >รหัสไปรษณีย์</v-col
                        >
                        <v-col cols="12" sm="8" md="3" class="pt-0 pt-sm-3">{{
                          user.address.post_code_id
                        }}</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="form-title"
                    ><v-icon left>fas fa-envelope</v-icon
                    >ที่อยู่สำหรับจัดส่งเอกสาร</v-col
                  >
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-radio-group
                      class="mt-n1"
                      v-model="doc_delivery_address.is_household"
                      mandatory
                    >
                      <v-radio
                        :label="
                          is_person
                            ? 'ตามทะเบียนบ้าน'
                            : 'ตามทะเบียนกรมพัฒนาธุรกิจการค้า'
                        "
                        :value="true"
                        class="ppim-radio pb-7 pb-sm-0"
                        color="purple"
                      ></v-radio>
                      <v-radio
                        :label="'อื่น ๆ'"
                        :value="false"
                        class="ppim-radio"
                        color="purple"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <div v-if="!doc_delivery_address.is_household" class="mt-n2">
                  <v-row>
                    <v-col cols="12">
                      <p class="text-caption">
                        โปรดใส่เครื่องหมาย - ในกรณีที่ไม่มีข้อมูล
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right pt-0 pt-sm-2 pb-0 label"
                      >หมู่บ้าน/อาคาร <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="8" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="หมู่บ้าน / อาคาร"
                        rules="required|max:50"
                      >
                        <v-text-field
                          dense
                          counter="50"
                          maxlength="50"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.home_name"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="3" class="text-sm-right pt-4 label"
                      >ห้อง <span class="red--text">*</span></v-col
                    >
                    <v-col cols="8" sm="3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ห้อง"
                        rules="required|max:10"
                      >
                        <v-text-field
                          dense
                          counter="10"
                          maxlength="10"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.room_no"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4" sm="2" class="text-sm-right pt-4 label"
                      >ชั้น <span class="red--text">*</span></v-col
                    >
                    <v-col cols="8" sm="3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ชั้น"
                        rules="required|max:10"
                      >
                        <v-text-field
                          dense
                          counter="10"
                          maxlength="10"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.floor"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="3" class="text-sm-right pt-4 label"
                      >บ้านเลขที่ <span class="red--text">*</span></v-col
                    >
                    <v-col cols="6" sm="3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="บ้านเลขที่"
                        rules="required|max:20"
                      >
                        <v-text-field
                          dense
                          counter="20"
                          maxlength="20"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.home_no"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4" sm="2" class="text-sm-right pt-4 label"
                      >หมู่ที่ <span class="red--text">*</span></v-col
                    >
                    <v-col cols="8" sm="3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="หมู่ที่"
                        rules="required|max:10"
                      >
                        <v-text-field
                          dense
                          counter="10"
                          maxlength="10"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.moo"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right pt-0 pt-sm-2 pb-0 label"
                      >ตรอก <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ตรอก"
                        rules="required|max:20"
                      >
                        <v-text-field
                          dense
                          counter="20"
                          maxlength="20"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.alley"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      class="text-sm-right pt-0 pt-sm-2 pb-0 label"
                      >ซอย <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ซอย"
                        rules="required|max:20"
                      >
                        <v-text-field
                          dense
                          counter="20"
                          maxlength="20"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.soi"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right py-0 pt-sm-2 label"
                      >ถนน <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="8" md="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ถนน"
                        rules="required|max:20"
                      >
                        <v-text-field
                          dense
                          counter="20"
                          maxlength="20"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.street"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right py-0 pt-sm-2 label"
                      >จังหวัด <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="8" md="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="จังหวัด"
                        rules="required"
                      >
                        <v-autocomplete
                          dense
                          placeholder="ระบุจังหวัด"
                          :items="geo.province"
                          :error-messages="errors"
                          item-text="province_text"
                          item-value="province_id"
                          v-model="doc_delivery_address.address.province_id"
                          @change="doc_delivery_address.address.amphor_id = ''"
                        ></v-autocomplete>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right py-0 pt-sm-2 label"
                      >อำเภอ/เขต <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="8" md="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="อำเภอ / เขต"
                        rules="required"
                      >
                        <v-autocomplete
                          dense
                          :placeholder="
                            doc_delivery_address.address.province_id == ''
                              ? 'โปรดระบุจังหวัดก่อน'
                              : 'ระบุอำเภอ'
                          "
                          :items="
                            amphorFilter(
                              doc_delivery_address.address.province_id
                            )
                          "
                          :error-messages="errors"
                          :disabled="
                            doc_delivery_address.address.province_id == ''
                          "
                          item-text="amphor_text"
                          item-value="amphor_id"
                          v-model="doc_delivery_address.address.amphor_id"
                          @change="doc_delivery_address.address.tumbon_id = ''"
                        ></v-autocomplete>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right py-0 pt-sm-2 label"
                      >ตำบล/แขวง <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="8" md="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ตำบล / แขวง"
                        rules="required"
                      >
                        <v-autocomplete
                          dense
                          :placeholder="
                            doc_delivery_address.address.amphor_id == ''
                              ? 'โปรดระบุอำเภอก่อน'
                              : 'ระบุตำบล'
                          "
                          :items="
                            tumbonFilter(doc_delivery_address.address.amphor_id)
                          "
                          item-text="tumbon_text"
                          item-value="tumbon_id"
                          :error-messages="errors"
                          :disabled="
                            doc_delivery_address.address.province_id == '' ||
                              doc_delivery_address.address.amphor_id == ''
                          "
                          v-model="doc_delivery_address.address.tumbon_id"
                        ></v-autocomplete>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="text-sm-right py-0 pt-sm-2 label"
                      >รหัสไปรษณีย์ <span class="red--text">*</span></v-col
                    >
                    <v-col cols="12" sm="3" class="pt-0">
                      <validation-provider
                        v-slot="{ errors }"
                        name="รหัสไปรษณีย์"
                        rules="required|length:5|numeric"
                      >
                        <v-text-field
                          dense
                          counter="5"
                          maxlength="5"
                          :error-messages="errors"
                          v-model="doc_delivery_address.address.postcode"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </div>
                <v-row>
                  <v-col class="form-title pt-0"
                    ><v-icon left>fas fa-address-book</v-icon
                    >ข้อมูลผู้ยื่นคำร้องขอขายไฟ / ผู้ประสานงานโครงการ</v-col
                  >
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >ชื่อ - นามสกุล <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="8" md="4" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="ชื่อ - นามสกุล"
                      rules="required|max:40"
                    >
                      <v-text-field
                        dense
                        counter="40"
                        maxlength="40"
                        placeholder="ระบุชื่อ - นามสกุล"
                        :error-messages="errors"
                        required
                        v-model="coordinator.name"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >โทรศัพท์ <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="8" md="4" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="หมายเลขโทรศัพท์"
                      rules="required|min:9|max:30"
                    >
                      <v-text-field
                        dense
                        counter="30"
                        minlength="9"
                        maxlength="30"
                        placeholder="หมายเลขโทรศัพท์เคลื่อนที่"
                        required
                        :error-messages="errors"
                        v-model="coordinator.tel"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >โทรสาร</v-col
                  >
                  <v-col cols="12" sm="8" md="4" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="หมายเลขโทรสาร"
                      rules="max:30"
                    >
                      <v-text-field
                        dense
                        counter="30"
                        maxlength="30"
                        placeholder="ระบุหมายเลขโทรสาร"
                        :error-messages="errors"
                        v-model="coordinator.fax"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- <v-row>
                                    <v-col cols="12" sm="3" class="text-sm-right py-0 pt-sm-2 label">อีเมล <span class="red--text">*</span></v-col>
                                    <v-col cols="12" sm="8" md="4" class="pt-0">
                                        <validation-provider v-slot="{ errors }" name="อีเมล" rules="required|email|max:40">
                                            <v-text-field
                                                dense counter="40" maxlength="40"
                                                placeholder="ระบุอีเมลแอดเดรสที่ใช้ติดต่อ"
                                                type="email"
                                                required
                                                :error-messages="errors"
                                                v-model="coordinator.email"
                                            ></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                </v-row> -->
                <v-btn
                  color="purple ligthen-2"
                  @click="e6 = 2"
                  class="ppim-btn mt-2"
                  dark
                  depressed
                >
                  ถัดไป
                </v-btn>
              </v-stepper-content>
              <v-stepper-step
                editable
                step="2"
                color="purple"
                :complete="e6 > 2"
              >
                ที่ตั้งโครงการ
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-row>
                  <v-col class="form-title"
                    ><v-icon left>fas fa-globe-asia</v-icon
                    >พิกัดภูมิศาสตร์</v-col
                  >
                  <v-col cols="12">
                    <p class="text-caption">
                      โปรดระบุในรูปแบบ ละติจูด (Latitude) และลองจิจูด
                      (Longitude) พร้อมใส่ทศนิยม 6 ตำแหน่ง เท่านั้น
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >ละติจูด <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="6" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="ละติจูด"
                      rules="required|double:6|max:10|min_value:-90|max_value:90"
                    >
                      <v-text-field
                        dense
                        counter="10"
                        maxlength="10"
                        suffix="N"
                        hint="ตัวอย่างเช่น -90.000000"
                        type="number"
                        step="0.000001"
                        placeholder="ระบุละติจูด"
                        :error-messages="errors"
                        v-model="project_location.latitude"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >ลองจิจูด <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="6" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="ลองจิจูด"
                      rules="required|double:6|max:11|min_value:-180|max_value:180"
                    >
                      <v-text-field
                        dense
                        counter="11"
                        maxlength="11"
                        suffix="E"
                        hint="ตัวอย่างเช่น -180.000000"
                        type="number"
                        step="0.000001"
                        placeholder="ระบุลองจิจูด"
                        :error-messages="errors"
                        v-model="project_location.longitude"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="form-title"
                    ><v-icon left>fas fa-map-marker-alt</v-icon
                    >ที่ตั้งโครงการ</v-col
                  >
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >จังหวัด <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="6" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="จังหวัด"
                      rules="required"
                    >
                      <v-autocomplete
                        dense
                        placeholder="ระบุจังหวัด"
                        :items="geo.province"
                        item-text="province_text"
                        item-value="province_id"
                        :error-messages="errors"
                        v-model="project_location.province_id"
                        @change="project_location.amphor_id = ''"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >อำเภอ <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="6" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="อำเภอ"
                      rules="required"
                    >
                      <v-autocomplete
                        dense
                        :placeholder="
                          project_location.province_id == ''
                            ? 'โปรดระบุจังหวัดก่อน'
                            : 'ระบุอำเภอ'
                        "
                        :items="amphorFilter(project_location.province_id)"
                        item-text="amphor_text"
                        item-value="amphor_id"
                        :disabled="project_location.province_id == ''"
                        :error-messages="errors"
                        v-model="project_location.amphor_id"
                        @change="project_location.tumbon_id = ''"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    class="text-sm-right py-0 pt-sm-2 label"
                    >ตำบล <span class="red--text">*</span></v-col
                  >
                  <v-col cols="12" sm="6" class="pt-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="ตำบล"
                      rules="required"
                    >
                      <v-autocomplete
                        dense
                        :placeholder="
                          project_location.amphor_id == ''
                            ? 'โปรดระบุจังหวัดอำเภอก่อน'
                            : 'ระบุตำบล'
                        "
                        :items="tumbonFilter(project_location.amphor_id)"
                        item-text="tumbon_text"
                        item-value="tumbon_id"
                        :disabled="
                          project_location.province_id == '' ||
                            project_location.amphor_id == ''
                        "
                        :error-messages="errors"
                        v-model="project_location.tumbon_id"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-btn
                  color="purple ligthen-2"
                  @click="e6 = 3"
                  class="ppim-btn mt-2 mr-1"
                  dark
                  depressed
                >
                  ถัดไป
                </v-btn>
                <v-btn color="grey" @click="e6 = 1" class="ppim-btn mt-2" text>
                  ย้อนกลับ
                </v-btn>
              </v-stepper-content>
              <v-stepper-step
                step="3"
                editable
                color="purple"
                :complete="e6 > 3"
              >
                ข้อมูลทางเทคนิค
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-col cols="12 text-center mb-4 pt-0">
                  <h3 class="red--text">
                    **
                    {{ label_by_project_type.energy_header }}
                    **
                  </h3>
                </v-col>

                <v-row class="d-none d-sm-flex">
                  <v-col cols="4" class="text-center label"
                    >ประเภทพลังงานหมุนเวียน
                    <span class="red--text">*</span></v-col
                  >
                  <v-col cols="4" class="text-center label"
                    >{{ label_by_project_type.energy_1st_value }}
                    <span class="red--text">*</span></v-col
                  >
                  <v-col cols="4" class="text-center label"
                    >{{ label_by_project_type.energy_2nd_value }}
                    <span class="red--text">*</span></v-col
                  >
                </v-row>
                <v-row v-for="(energy, index) in allowed_energy" :key="index">
                  <v-col cols="12" sm="4" class="py-0">
                    <v-checkbox
                      :label="energy.energy_sub_text"
                      @change="clearSubEnergy(energy._id)"
                      v-model="selected_energy[energy._id].selected"
                      color="purple"
                      class="ppim-checkbox mt-0"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" class="py-0 d-sm-none label"
                    ><small>{{
                      label_by_project_type.energy_1st_value
                    }}</small></v-col
                  >
                  <v-col cols="12" sm="4" class="py-0">
                    <!-- <validation-provider v-slot="{ errors }" immediate name="ขนาดกำลังการผลิตติดตั้ง" :rules="{ required: selected_energy[energy._id].selected ? true : false, gtz: selected_energy[energy._id].selected ? true : false }"> -->
                    <validation-provider
                      v-slot="{ errors }"
                      immediate
                      :name="label_by_project_type.energy_1st_value"
                      :rules="{
                        required: !isChildSelected(energy._id)
                      }"
                    >
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        step="0.01"
                        :suffix="project_data.project_unit"
                        :disabled="isChildSelected(energy._id)"
                        :error-messages="errors"
                        :value="selected_energy[energy._id].produce"
                        @input="setEnergyProduce($event, energy._id)"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" class="py-0 d-sm-none mt-n5 label"
                    ><small>{{
                      label_by_project_type.energy_2nd_value
                    }}</small></v-col
                  >
                  <v-col cols="12" sm="4" class="py-0">
                    <!-- <validation-provider v-slot="{ errors }" immediate name="ปริมาณพลังไฟฟ้าเสนอขาย" :rules="{ required: selected_energy[energy._id].selected ? true : false, gtz: selected_energy[energy._id].selected ? true : false }"> -->
                    <validation-provider
                      v-slot="{ errors }"
                      immediate
                      :name="label_by_project_type.energy_2nd_value"
                      :rules="{
                        required: !isChildSelected(energy._id)
                      }"
                    >
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        step="0.01"
                        :suffix="project_data.project_unit"
                        :disabled="isChildSelected(energy._id)"
                        :error-messages="errors"
                        v-model="selected_energy[energy._id].offer"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <template v-for="sub_energy in energy.energy_sub_type">
                    <v-col
                      cols="12"
                      sm="4"
                      class="pl-3 pl-sm-10 py-0"
                      :key="sub_energy._id"
                    >
                      <v-checkbox
                        :label="sub_energy.energy_sub_text"
                        v-model="selected_energy[sub_energy._id].selected"
                        @change="clearParentEnergy(sub_energy._id)"
                        color="purple lighten-2"
                        class="ppim-checkbox mt-0"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" class="py-0 d-sm-none label"
                      ><small>{{
                        label_by_project_type.energy_1st_value
                      }}</small></v-col
                    >
                    <v-col
                      cols="12"
                      sm="4"
                      class="py-0"
                      :key="sub_energy._id + '-p'"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="label_by_project_type.energy_1st_value"
                        immediate
                        :rules="{
                          required: selected_energy[sub_energy._id].selected
                            ? true
                            : false,
                          gtz: selected_energy[sub_energy._id].selected
                            ? true
                            : false
                        }"
                      >
                        <v-text-field
                          outlined
                          dense
                          single-line
                          type="number"
                          step="0.01"
                          :suffix="project_data.project_unit"
                          :disabled="!selected_energy[sub_energy._id].selected"
                          :error-messages="errors"
                          v-model="selected_energy[sub_energy._id].produce"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" class="py-0 d-sm-none mt-n5 label"
                      ><small>{{
                        label_by_project_type.energy_2nd_value
                      }}</small></v-col
                    >
                    <v-col
                      cols="12"
                      sm="4"
                      class="py-0"
                      :key="sub_energy._id + '-o'"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="label_by_project_type.energy_2nd_value"
                        immediate
                        :rules="{
                          required: selected_energy[sub_energy._id].selected
                            ? true
                            : false,
                          gtz: selected_energy[sub_energy._id].selected
                            ? true
                            : false
                        }"
                      >
                        <v-text-field
                          outlined
                          dense
                          type="number"
                          step="0.01"
                          :suffix="project_data.project_unit"
                          :disabled="!selected_energy[sub_energy._id].selected"
                          :error-messages="errors"
                          v-model="selected_energy[sub_energy._id].offer"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </template>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card
                      elevation="0"
                      color="grey lighten-4"
                      class="pa-5 mt-n5 mt-sm-0"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right d-none d-sm-block pt-sm-4 label"
                          >รวมทั้งหมด</v-col
                        >
                        <v-col cols="12" class="d-sm-none pb-0 label">{{
                          label_by_project_type.energy_total_1st_value
                        }}</v-col>
                        <v-col cols="12" sm="4" class="pt-0 pt-sm-4">
                          <vuetify-money
                            dense
                            readonly
                            :valueWhenIsEmpty="'0'"
                            :options="{
                              precision: 6,
                              suffix: project_data.project_unit,
                              min: 0
                            }"
                            v-model="total_produce"
                          ></vuetify-money>
                        </v-col>
                        <v-col cols="12" class="d-sm-none py-0 label">{{
                          label_by_project_type.energy_total_2nd_value
                        }}</v-col>
                        <v-col cols="12" sm="4" class="pt-0 pt-sm-4">
                          <vuetify-money
                            dense
                            readonly
                            :valueWhenIsEmpty="'0'"
                            :options="{
                              precision: 6,
                              suffix: project_data.project_unit,
                              min: 0
                            }"
                            v-model="total_offer"
                          ></vuetify-money>
                        </v-col>
                      </v-row>
                      <v-row v-if="project_data.project_guarantee.is_guarantee">
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right py-0 pb-sm-3 label"
                          >จำนวนเงินวางหลักประกัน</v-col
                        >
                        <v-col cols="12" sm="8" class="pt-0">
                          <v-text-field
                            dense
                            readonly
                            :value="paid_amount | money_format"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          project_data.project_type.project_type_id === 4 &&
                            project_data.is_require_contract
                        "
                      >
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right py-0 pb-sm-3 label"
                          >เลขที่สัญญาซื้อขายไฟฟ้า
                          <span class="red--text">*</span></v-col
                        >
                        <v-col cols="12" sm="8" class="pt-0">
                          <validation-provider
                            v-slot="{ errors }"
                            name="เลขที่สัญญาซื้อขายไฟฟ้า"
                            rules="required|max:30"
                          >
                            <v-text-field
                              dense
                              counter="30"
                              maxlength="30"
                              placeholder="เลขที่สัญญาซื้อขายไฟฟ้า"
                              required
                              :error-messages="errors"
                              v-model="electric_sale_contract_number"
                            >
                            </v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          project_data.project_type.project_type_id === 4 &&
                            project_data.is_require_contract == false
                        "
                      >
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right pb-sm-3 label"
                          >หนังสือแจ้งผลการพิจารณาจุดเชื่อมต่อจาก กฟภ.
                          <span class="red--text">*</span></v-col
                        >
                        <v-col cols="12" sm="8" class="pt-0">
                          <validation-provider
                            name="หนังสือแจ้งผลการพิจารณาจุดเชื่อมต่อจาก กฟภ."
                            rules="required_upload|mimes:application/pdf|size:5120"
                            v-slot="{
                              errors
                            }"
                          >
                            <v-file-input
                              v-model="file_announce[0]"
                              show-size
                              accept="application/pdf"
                              color="purple lighten-2"
                              class="pt-0"
                              placeholder="กรุณาแนบไฟล์ขนาดไม่เกิน 5 MB"
                              :error-messages="errors"
                            ></v-file-input>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          project_data.project_type.project_type_id === 4 &&
                            project_data.is_require_contract == false &&
                            total_produce > 6
                        "
                      >
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right pb-sm-3 label"
                          >หนังสือแจ้งผลจาก กฟผ. (กรณีกำลังผลิตติดตั้ง มากกว่า 6
                          MW) <span class="red--text">*</span></v-col
                        >
                        <v-col cols="12" sm="8" class="pt-0">
                          <validation-provider
                            name="หนังสือแจ้งผลจาก กฟผ."
                            rules="required_upload|mimes:application/pdf|size:5120"
                            v-slot="{
                              errors
                            }"
                          >
                            <v-file-input
                              v-model="file_announce[1]"
                              show-size
                              accept="application/pdf"
                              color="purple lighten-2"
                              class="pt-0"
                              placeholder="กรุณาแนบไฟล์ขนาดไม่เกิน 5 MB"
                              :error-messages="errors"
                            ></v-file-input>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          project_data.project_type.project_type_id === 4 &&
                            project_data.is_require_contract == false
                        "
                      >
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right pb-sm-3 label"
                          >ระดับแรงดันเชื่อมต่อ
                          <span class="red--text">*</span></v-col
                        >
                        <v-col cols="12" sm="8" class="pt-0">
                          <validation-provider
                            name="ระดับแรงดันเชื่อมต่อ"
                            rules="required"
                            v-slot="{
                              errors
                            }"
                          >
                            <v-select
                              v-model="voltage_level"
                              :items="items_voltage_level"
                              dense
                              :error-messages="errors"
                            ></v-select>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="project_data.project_type.project_type_id === 4"
                      >
                        <v-col
                          cols="12"
                          sm="4"
                          class="text-sm-right pb-sm-3 label"
                          >กำหนดวันจ่ายไฟฟ้าเข้าระบบเชิงพาณิชย์ (SCOD)
                          <span class="red--text">*</span></v-col
                        >
                        <v-col cols="12" sm="8" class="">
                          <v-dialog
                            ref="dialog_top_up_electric_supply_date"
                            v-model="dialog_top_up_electric_supply_date"
                            :return-value.sync="top_up_electric_supply_date"
                            persistent
                            width="290px"
                          >
                            <template
                              v-slot:activator="{
                                on,
                                attrs
                              }"
                            >
                              <validation-provider
                                v-slot="{
                                  errors
                                }"
                                name="วันจ่ายไฟฟ้าเข้าระบบเชิงพาณิชย์"
                                vid="top_up_electric_supply_date"
                                rules="required"
                              >
                                <v-text-field
                                  :value="
                                    dateUtcToThaiFormat(
                                      top_up_electric_supply_date
                                    )
                                  "
                                  dense
                                  append-icon="far fa-calendar-alt"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="top_up_electric_supply_date"
                              :min="current_iso_date"
                              scrollable
                              locale="th-th"
                              color="purple"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                class="ppim-btn"
                                color="grey"
                                text
                                @click="
                                  dialog_top_up_electric_supply_date = false
                                "
                                >ยกเลิก</v-btn
                              >
                              <v-btn
                                class="ppim-btn"
                                color="purple lighten-2"
                                dark
                                depressed
                                @click="
                                  $refs.dialog_top_up_electric_supply_date.save(
                                    top_up_electric_supply_date
                                  )
                                "
                                >ยืนยัน</v-btn
                              >
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-btn
                  color="purple ligthen-2"
                  @click="e6 = 4"
                  class="ppim-btn mt-3 mr-1"
                  dark
                  depressed
                >
                  ถัดไป
                </v-btn>
                <v-btn color="grey" @click="e6 = 2" class="ppim-btn mt-3" text>
                  ย้อนกลับ
                </v-btn>
              </v-stepper-content>
              <v-stepper-step editable step="4" color="purple">
                ยอมรับเงื่อนไขการยื่นคำเสนอขอขายไฟฟ้า
              </v-stepper-step>
              <v-stepper-content step="4">
                <v-row
                  v-for="(agreement, index) in project_data.project_agreement"
                  :key="index"
                  class="pb-2"
                >
                  <v-col cols="12" sm="1">
                    <validation-provider
                      name="เงื่อนไข"
                      rules="accept"
                      v-slot="{ errors }"
                    >
                      <v-checkbox
                        v-model="project_agreement[index]"
                        :error-messages="errors"
                        value="1"
                        color="purple"
                        class="ppim-checkbox mt-0"
                      ></v-checkbox>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="11" class="pt-0 pt-sm-3">
                    {{ agreement.agreement_detail }}
                  </v-col>
                </v-row>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="my-1" align="center">
        <v-col class="text-center">
          <v-dialog
            v-model="dialog_confirm"
            max-width="500"
            min-width="400"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ppim-btn white--text"
                color="purple darken-2"
                large
                v-bind="attrs"
                v-on="on"
                :disabled="invalid || invalid_select_energy || not_accept_all"
              >
                <v-icon left>fas fa-save</v-icon>ยื่นคำร้อง
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="purple darken-2 pt-3">
                <v-icon left large color="white" class="d-none d-sm-flex"
                  >fas fa-exclamation-circle</v-icon
                >
                <span
                  class="white--text text-subtitle-1 text-sm-h6"
                  id="confirm-title"
                  >กรุณาตรวจสอบความถูกต้อง</span
                >
              </v-card-title>
              <v-card-text class="pt-5">
                <p class="mb-0">
                  เมื่อยื่นคำร้องแล้วจะไม่สามารถแก้ไขข้อมูลได้อีกในภายหลัง
                  หากตรวจสอบความถูกต้องเรียบร้อยแล้วให้กดปุ่ม
                  <strong class="text-decoration-underline">ตกลง</strong>
                </p>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="purple"
                  dark
                  depressed
                  @click="save"
                  class="ppim-btn"
                >
                  ตกลง
                </v-btn>
                <v-btn
                  color="grey darken-1"
                  text
                  @click="dialog_confirm = false"
                  class="ppim-btn"
                >
                  ย้อนกลับ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </validation-observer>
    <v-dialog v-model="dialog_load" persistent width="300">
      <v-card color="secondary" dark>
        <v-card-text class="pa-3">
          {{ dialog_load_message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-3"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <dialog-alert
      v-model="dialog_alert.show"
      :type="dialog_alert.type"
      :title="dialog_alert.title"
      :message="dialog_alert.message"
    ></dialog-alert>
  </div>
</template>

<script>
import { _, DateTime } from "@/plugins/app";
import api from "@/plugins/axios";
import "@/plugins/vuetify-money.js";
import { PROJECT_TYPE } from "@/helpers/constant";
import { dialog_data, dialog_methods } from "@/helpers/dialog";
import { date_format } from "@/helpers/date_format";
import DialogAlert from "@/components/DialogAlert";

export default {
  components: {
    DialogAlert
  },
  data: () => ({
    e6: 1,
    project_data: {
      project_type: { project_type_id: null },
      project_guarantee: { guarantee_condition_by: null },
      is_require_contract: null
    },
    geo: {
      tumbon: [],
      amphor: [],
      province: []
    },
    user: {
      address: {},
      address_contact: {},
      businessPartner: {}
    },
    doc_delivery_address: {
      is_household: true,
      address: {
        home_name: "-",
        room_no: "-",
        floor: "-",
        home_no: "-",
        moo: "-",
        alley: "-",
        soi: "-",
        street: "-",
        tumbon_id: "",
        amphor_id: "",
        province_id: "",
        tumbon_text: "",
        amphor_text: "",
        province_text: "",
        postcode: ""
      }
    },
    coordinator: {
      name: "",
      tel: "",
      fax: "",
      email: ""
    },
    project_location: {
      tumbon_id: "",
      amphor_id: "",
      province_id: "",
      tumbon_text: "",
      amphor_text: "",
      province_text: ""
    },
    project_agreement: [],
    allowed_energy: [],
    electric_sale_contract_number: "",
    top_up_electric_supply_date: null,

    file_announce: [],
    voltage_level: null,
    items_voltage_level: ["69 - 115 kV", "22 - 33 kV", "ต่ำกว่า 22 kV"],

    dialog_load: true,
    dialog_load_message: "กำลังดึงข้อมูล",
    dialog_confirm: false,
    dialog_top_up_electric_supply_date: false,

    ...dialog_data,

    selected_energy: {
      "1-00": {
        selected: false
      },
      "1-01": {
        selected: false
      },
      "1-02": {
        selected: false
      },
      "1-03": {
        selected: false
      },
      "1-04": {
        selected: false
      },
      "1-05": {
        selected: false
      },
      "1-06": {
        selected: false
      },
      "1-07": {
        selected: false
      },
      "1-08": {
        selected: false
      },
      "1-09": {
        selected: false
      },
      "1-10": {
        selected: false
      },
      "2-00": {
        selected: false
      },
      "2-01": {
        selected: false
      },
      "2-02": {
        selected: false
      },
      "2-03": {
        selected: false
      },
      "2-04": {
        selected: false
      },
      "2-05": {
        selected: false
      },
      "2-06": {
        selected: false
      },
      "2-07": {
        selected: false
      },
      "2-08": {
        selected: false
      },
      "2-09": {
        selected: false
      },
      "2-10": {
        selected: false
      },
      "3-00": {
        selected: false
      },
      "3-01": {
        selected: false
      },
      "3-02": {
        selected: false
      },
      "3-03": {
        selected: false
      },
      "3-04": {
        selected: false
      },
      "3-05": {
        selected: false
      },
      "3-06": {
        selected: false
      },
      "3-07": {
        selected: false
      },
      "3-08": {
        selected: false
      },
      "3-09": {
        selected: false
      },
      "3-10": {
        selected: false
      },
      "4-00": {
        selected: false
      },
      "4-01": {
        selected: false
      },
      "4-02": {
        selected: false
      },
      "4-03": {
        selected: false
      },
      "4-04": {
        selected: false
      },
      "4-05": {
        selected: false
      },
      "4-06": {
        selected: false
      },
      "4-07": {
        selected: false
      },
      "4-08": {
        selected: false
      },
      "4-09": {
        selected: false
      },
      "4-10": {
        selected: false
      },
      "5-00": {
        selected: false
      },
      "5-01": {
        selected: false
      },
      "5-02": {
        selected: false
      },
      "5-03": {
        selected: false
      },
      "5-04": {
        selected: false
      },
      "5-05": {
        selected: false
      },
      "5-06": {
        selected: false
      },
      "5-07": {
        selected: false
      },
      "5-08": {
        selected: false
      },
      "5-09": {
        selected: false
      },
      "5-10": {
        selected: false
      },
      "6-00": {
        selected: false
      },
      "6-01": {
        selected: false
      },
      "6-02": {
        selected: false
      },
      "6-03": {
        selected: false
      },
      "6-04": {
        selected: false
      },
      "6-05": {
        selected: false
      },
      "6-06": {
        selected: false
      },
      "6-07": {
        selected: false
      },
      "6-08": {
        selected: false
      },
      "6-09": {
        selected: false
      },
      "6-10": {
        selected: false
      },
      "7-00": {
        selected: false
      },
      "7-01": {
        selected: false
      },
      "7-02": {
        selected: false
      },
      "7-03": {
        selected: false
      },
      "7-04": {
        selected: false
      },
      "7-05": {
        selected: false
      },
      "7-06": {
        selected: false
      },
      "7-07": {
        selected: false
      },
      "7-08": {
        selected: false
      },
      "7-09": {
        selected: false
      },
      "7-10": {
        selected: false
      },
      "8-00": {
        selected: false
      },
      "8-01": {
        selected: false
      },
      "8-02": {
        selected: false
      },
      "8-03": {
        selected: false
      },
      "8-04": {
        selected: false
      },
      "8-05": {
        selected: false
      },
      "8-06": {
        selected: false
      },
      "8-07": {
        selected: false
      },
      "8-08": {
        selected: false
      },
      "8-09": {
        selected: false
      },
      "8-10": {
        selected: false
      },
      "9-00": {
        selected: false
      },
      "9-01": {
        selected: false
      },
      "9-02": {
        selected: false
      },
      "9-03": {
        selected: false
      },
      "9-04": {
        selected: false
      },
      "9-05": {
        selected: false
      },
      "9-06": {
        selected: false
      },
      "9-07": {
        selected: false
      },
      "9-08": {
        selected: false
      },
      "9-09": {
        selected: false
      },
      "9-10": {
        selected: false
      },
      "10-00": {
        selected: false
      },
      "10-01": {
        selected: false
      },
      "10-02": {
        selected: false
      },
      "10-03": {
        selected: false
      },
      "10-04": {
        selected: false
      },
      "10-05": {
        selected: false
      },
      "10-06": {
        selected: false
      },
      "10-07": {
        selected: false
      },
      "10-08": {
        selected: false
      },
      "10-09": {
        selected: false
      },
      "10-10": {
        selected: false
      },
      "11-00": {
        selected: false
      },
      "11-01": {
        selected: false
      },
      "11-02": {
        selected: false
      },
      "11-03": {
        selected: false
      },
      "11-04": {
        selected: false
      },
      "11-05": {
        selected: false
      },
      "11-06": {
        selected: false
      },
      "11-07": {
        selected: false
      },
      "11-08": {
        selected: false
      },
      "11-09": {
        selected: false
      },
      "11-10": {
        selected: false
      },
      "12-00": {
        selected: false
      },
      "12-01": {
        selected: false
      },
      "12-02": {
        selected: false
      },
      "12-03": {
        selected: false
      },
      "12-04": {
        selected: false
      },
      "12-05": {
        selected: false
      },
      "12-06": {
        selected: false
      },
      "12-07": {
        selected: false
      },
      "12-08": {
        selected: false
      },
      "12-09": {
        selected: false
      },
      "12-10": {
        selected: false
      },
      "13-00": {
        selected: false
      },
      "13-01": {
        selected: false
      },
      "13-02": {
        selected: false
      },
      "13-03": {
        selected: false
      },
      "13-04": {
        selected: false
      },
      "13-05": {
        selected: false
      },
      "13-06": {
        selected: false
      },
      "13-07": {
        selected: false
      },
      "13-08": {
        selected: false
      },
      "13-09": {
        selected: false
      },
      "13-10": {
        selected: false
      },
      "14-00": {
        selected: false
      },
      "14-01": {
        selected: false
      },
      "14-02": {
        selected: false
      },
      "14-03": {
        selected: false
      },
      "14-04": {
        selected: false
      },
      "14-05": {
        selected: false
      },
      "14-06": {
        selected: false
      },
      "14-07": {
        selected: false
      },
      "14-08": {
        selected: false
      },
      "14-09": {
        selected: false
      },
      "14-10": {
        selected: false
      },
      "15-00": {
        selected: false
      },
      "15-01": {
        selected: false
      },
      "15-02": {
        selected: false
      },
      "15-03": {
        selected: false
      },
      "15-04": {
        selected: false
      },
      "15-05": {
        selected: false
      },
      "15-06": {
        selected: false
      },
      "15-07": {
        selected: false
      },
      "15-08": {
        selected: false
      },
      "15-09": {
        selected: false
      },
      "15-10": {
        selected: false
      }
    }
  }),
  methods: {
    ...date_format,
    createViewEnergyType(energy_type) {
      let view_energy_type = [];

      _.forEach(energy_type, (parent, key) => {
        let [parent_key, sub] = _.split(parent._id, "-");

        if (parent.is_checked == true) {
          view_energy_type.push({
            _id: parent._id,
            energy_sub_text: parent.energy_sub_text,
            is_checked: true,
            energy_sub_type: []
          });
          this.selected_energy[parent._id] = {
            _id: parent._id,
            selected: false,
            energy_type_text: parent.energy_sub_text,
            produce: null,
            offer: null
          };

          let other = _.find(parent.energy_sub_type, {
            _id: parent_key + "-99"
          });

          if (other && other.is_checked == true) {
            return; // continue
          } else {
            _.forEach(parent.energy_sub_type, child => {
              if (child.is_checked == true && child._id != parent_key + "-99") {
                let curr_parent = _.last(view_energy_type);

                curr_parent.energy_sub_type.push({
                  _id: child._id,
                  energy_sub_text: child.energy_sub_text,
                  is_checked: true
                });

                this.selected_energy[child._id] = {
                  _id: child._id,
                  selected: false,
                  energy_type_text: child.energy_sub_text,
                  produce: null,
                  offer: null
                };
              }
            });
          }
        }
      });

      return view_energy_type;
    },
    setEnergyProduce(value, energy_id) {
      this.selected_energy[energy_id].produce = value;
    },
    clearParentEnergy(energy_id) {
      let [parent_key, sub] = _.split(energy_id, "-");
      let parent_id = parent_key + "-00";

      let parent_selected = false;

      if (this.selected_energy[energy_id].selected) {
        parent_selected = true;
      } else {
        parent_selected = this.isOtherChildSelected(parent_id, energy_id)
          ? true
          : false;

        this.selected_energy[energy_id].produce = null;
        this.selected_energy[energy_id].offer = null;
      }

      this.selected_energy[parent_id].selected = parent_selected;
      this.selected_energy[parent_id].produce = null;
      this.selected_energy[parent_id].offer = null;
    },
    clearSubEnergy(energy_id) {
      let parent = _.find(this.allowed_energy, { _id: energy_id });

      if (parent.energy_sub_type.length > 0) {
        _.forEach(parent.energy_sub_type, sub_energy => {
          this.selected_energy[sub_energy._id].selected = false;
          this.selected_energy[sub_energy._id].produce = null;
          this.selected_energy[sub_energy._id].offer = null;
        });
      }

      if (!this.selected_energy[energy_id].selected) {
        this.selected_energy[energy_id].produce = null;
        this.selected_energy[energy_id].offer = null;
      }
    },
    isOtherChildSelected(parent_id, except_id) {
      let parent = _.find(this.allowed_energy, { _id: parent_id });
      let selected = false;
      _.forEach(parent.energy_sub_type, child => {
        if (child._id != except_id) {
          if (this.selected_energy[child._id].selected) {
            selected = true;
            return false;
          }
        }
      });

      return selected;
    },
    isChildSelected(energy_id) {
      let parent = _.find(this.allowed_energy, { _id: energy_id });

      if (parent == undefined) return false;

      if (parent.energy_sub_type.length > 0) {
        let is_child_selected = false;

        _.forEach(parent.energy_sub_type, sub_energy => {
          if (this.selected_energy[sub_energy._id].selected) {
            is_child_selected = true;
            return false;
          }
        });

        if (is_child_selected || !this.selected_energy[energy_id].selected)
          return true;
        else return false;
      } else {
        return !this.selected_energy[energy_id].selected;
      }
    },
    amphorFilter(province_id) {
      return _.filter(this.geo.amphor, { province_id: province_id });
    },
    tumbonFilter(amphor_id) {
      return _.filter(this.geo.tumbon, { amphor_id: amphor_id });
    },
    prepareDocDeliveryAddress() {
      let address = {};

      if (this.doc_delivery_address.is_household) {
        // destructuring
        ({ address } = this.user);

        address.postcode = address.post_code_id;
      } else {
        // destructuring
        ({ address } = this.doc_delivery_address);

        address.province_text = _.find(this.geo.province, {
          province_id: address.province_id
        }).province_text;
        address.amphor_text = _.find(this.geo.amphor, {
          amphor_id: address.amphor_id
        }).amphor_text;
        address.tumbon_text = _.find(this.geo.tumbon, {
          tumbon_id: address.tumbon_id
        }).tumbon_text;
      }

      return address;
    },
    prepareEnergyType() {
      let send = [];
      _.forEach(this.selected_energy, energy => {
        if (energy.selected) {
          if (energy.offer == null || energy.produce == null) {
            energy.offer = 0;
            energy.produce = 0;
          } else {
            energy.offer = parseFloat(energy.offer);
            energy.produce = parseFloat(energy.produce);
          }

          send.push(energy);
        }
      });

      return _.orderBy(send, ["_id"], ["asc"]);
    },
    prepareProjectLocation() {
      this.project_location.province_text = _.find(this.geo.province, {
        province_id: this.project_location.province_id
      }).province_text;
      this.project_location.amphor_text = _.find(this.geo.amphor, {
        amphor_id: this.project_location.amphor_id
      }).amphor_text;
      this.project_location.tumbon_text = _.find(this.geo.tumbon, {
        tumbon_id: this.project_location.tumbon_id
      }).tumbon_text;
    },

    save() {
      this.dialog_confirm = false;
      this.dialog_load_message = "กำลังบันทึกข้อมูล";
      this.dialog_load = true;

      this.prepareProjectLocation();

      let payload = {
        bp_address: this.user.address._id,

        doc_delivery_address: {
          is_household: this.doc_delivery_address.is_household,
          address: this.prepareDocDeliveryAddress()
        },
        coordinator: this.coordinator,

        project_location: this.project_location,

        energy_type: this.prepareEnergyType(),
        total_energy_producation: parseFloat(this.total_produce),
        total_energy_offer: parseFloat(this.total_offer),

        project_code: this.project_data.project_code,
        project_type: this.project_data.project_type.project_type_id,
        project_agreement: this.project_data.project_agreement
      };

      if (this.project_data.project_type.project_type_id === PROJECT_TYPE.ECO) {
        api
          .post("/request/eco", payload)
          .then(this.onStoreSuccess)
          .catch(this.onStoreError);
      } else if (
        this.project_data.project_type.project_type_id ===
        PROJECT_TYPE.EMERGENCY
      ) {
        let formData = new FormData();

        payload.is_require_contract = this.project_data.is_require_contract
          ? true
          : false;
        payload.top_up_electric_supply_date = DateTime.fromSQL(
          this.top_up_electric_supply_date
        ).toISO();

        if (this.project_data.is_require_contract) {
          payload.electric_sale_contract_number = this.electric_sale_contract_number;
        } else {
          payload.voltage_level = this.voltage_level;

          formData.append("file_announce[0]", this.file_announce[0]);

          if (this.total_produce > 6)
            formData.append("file_announce[1]", this.file_announce[1]);
        }

        formData.append("payload", JSON.stringify(payload));

        let options = {
          method: "post",
          url: "/request/emergency",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        api(options)
          // .post(, payload)
          .then(this.onStoreSuccess)
          .catch(this.onStoreError);
      }
    },
    onStoreSuccess(response) {
      if (response.data) {
        this.dialog_load = false;
        this.$router.replace({
          name: "request-eco-list",
          params: { noti: response.data.notification_no }
        });
      }
    },
    onStoreError(error) {
      if (error.response.status == 422) {
        this.showDialogAlert(
          true,
          "error",
          "เกิดข้อผิดพลาด",
          "ข้อมูลในการยื่นคำร้องไม่ถูกต้อง"
        );
        console.log(error.response.data);
      }
      this.dialog_load = false;
    },

    ...dialog_methods
  },
  computed: {
    unit_text() {
      return this.project_data.project_unit == "kW"
        ? "กิโลวัตต์ (kW)"
        : "เมกะวัตต์ (MW)";
    },
    total_produce() {
      let arr_produce = [];

      _.forEach(this.selected_energy, energy => {
        if (energy.selected) {
          if (!_.isNaN(parseFloat(energy.produce)))
            arr_produce.push(parseFloat(energy.produce));
        }
      });

      return _.sum(arr_produce);
    },
    total_offer() {
      let arr_offer = [];

      _.forEach(this.selected_energy, energy => {
        if (energy.selected) {
          if (!isNaN(parseFloat(energy.offer)))
            arr_offer.push(parseFloat(energy.offer));
        }
      });

      return _.sum(arr_offer);
    },
    paid_amount() {
      if (_.isEmpty(this.project_data)) return 0;

      let amount = 0;

      if (
        this.project_data.project_guarantee.guarantee_condition_by == "produce"
      )
        // amount = Big(this.total_produce)
        amount = this.total_produce;
      // amount = Big(this.total_offer)
      else amount = this.total_offer;

      // return amount.times(this.project_data.project_guarantee.guarantee_rate).round(2, 2)
      return (
        Math.ceil(
          amount * this.project_data.project_guarantee.guarantee_rate * 100
        ) / 100
      );
    },
    is_person() {
      return this.user.businessPartner.partner_type_id == 1 ? true : false;
    },
    full_name() {
      let { businessPartner } = this.user;

      if (businessPartner.partner_type_id == 1) {
        return (
          businessPartner.name_title +
          " " +
          businessPartner.name_first +
          " " +
          businessPartner.name_last
        );
      } else {
        return businessPartner.name_org_full;
      }
    },
    full_street() {
      if (!_.isEmpty(this.user.address)) {
        let result =
          this.user.address.alley +
          " " +
          this.user.address.soi +
          " " +
          this.user.address.street;
        return _.trim(result.replaceAll("-", " "));
      }
      return "-";
    },
    not_accept_all() {
      return this.project_agreement.some(val => val == null);
    },
    invalid_select_energy() {
      let invalid = false;
      let num_selected = 0;

      _.forEach(this.selected_energy, energy => {
        if (energy.selected) {
          num_selected++;
          if (this.isChildSelected(energy._id)) return; // continue loop

          if (_.isEmpty(energy.produce) || _.isEmpty(energy.offer)) {
            invalid = true;
            return false;
          } else if (
            parseFloat(energy.produce) <= 0 ||
            parseFloat(energy.offer) <= 0
          ) {
            invalid = true;
            return false;
          } else if (parseFloat(energy.produce) < parseFloat(energy.offer)) {
            invalid = true;
            return false;
          } else {
            invalid = false;
          }
        }
      });

      if (num_selected == 0) return true;

      return invalid;
    },
    label_by_project_type() {
      let labels = {};

      if (this.project_data.project_type.project_type_id === PROJECT_TYPE.ECO)
        labels = {
          energy_header: `โปรดกรอกขนาดกำลังการผลิดติดตั้งและปริมาณพลังไฟฟ้าเสนอขายเป็น ${this.unit_text}`,
          energy_1st_value: "ขนาดกำลังการผลิตติดตั้ง",
          energy_2nd_value: "ปริมาณพลังไฟฟ้าเสนอขาย",
          energy_total_1st_value: "รวมขนาดกำลังการผลิตติดตั้ง",
          energy_total_2nd_value: "รวมปริมาณพลังไฟฟ้าเสนอขาย"
        };
      else if (
        this.project_data.project_type.project_type_id ===
        PROJECT_TYPE.EMERGENCY
      )
        labels = {
          energy_header: `โปรดกรอกข้อมูลเป็น ${this.unit_text}`,
          energy_1st_value: "ขนาดกำลังการผลิตติดตั้ง",
          energy_2nd_value: "ปริมาณพลังไฟฟ้าเสนอขายครั้งนี้",
          energy_total_1st_value: "รวมขนาดกำลังการผลิตติดตั้ง",
          energy_total_2nd_value: "รวมปริมาณพลังไฟฟ้าเสนอขายครั้งนี้"
        };

      return labels;
    },
    current_iso_date() {
      let now = new Date();
      return now.toISOString();
    }
  },
  filters: {
    number_format(value) {
      if (!value) return 0;

      return value.toLocaleString("th-TH");
    },
    money_format(value) {
      if (!value) return 0.0;

      return value
        .toLocaleString("th-TH", {
          maximumFractionDigits: 2,
          style: "currency",
          currency: "THB"
        })
        .substr(1);
    }
  },
  created() {
    let requests = [
      api.get("/project/eco/" + this.$route.params.pid),
      api.get("/data/geo"),
      api.get("/data/business_partner")
    ];

    Promise.all(requests).then(response => {
      const project_data = response[0];
      const geo = response[1];
      const business_partner = response[2];

      if (project_data.data) {
        this.project_data = project_data.data;
        this.allowed_energy = this.createViewEnergyType(
          project_data.data.energy_type
        );
      }

      if (geo.data) {
        this.geo = geo.data;
      }

      if (business_partner.data) {
        this.user = business_partner.data;
      }

      this.dialog_load = false;
    });
  }
};
</script>
